import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { _AmortizationType, _LoanTimeTerm } from '../../../../core/services/dataBean/EntityCatalog';



interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
}

export const LoanTimeTermSelect = ({ idSelector, onChange, label }: Props) => {

    const { instance } = useDataBean(_LoanTimeTerm);
    const [lista, setLista] = useState<any>([])
    const [id, setID] = useState(0);

    useEffect(() => {
        if (idSelector >= 0) {
            setID(idSelector);
        }
    }, [])

    useEffect(() => {
        getLista();
    }, [])


    useEffect(() => {
        onChange(id);
    }, [id])

    const setValue = (e: any) => {
        setID(parseInt(e));
        onChange(id);
    }


    const getLista = () => {
        instance.getLoanTimeTermCatalog(null).then(
            (resp) => {
                setLista(resp)
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    return (
        <>
            <label>{label ?? "Tipos de Plazos para Créditos:"}</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option>...</option>
                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item.DataBeanProperties.IDLoanTimeTerm} >{item.DataBeanProperties.Name}</option>
                        )
                    })
                }
            </select>
        </>
    )
}